<template>
    <!-- <div class="loading"></div> -->
    <div v-loading.fullscreen.lock="loading"></div>
</template>
<script>
export default {
    data () {
        return {
            loading:false,
        }
    },
    mounted(){
        let self = this;
        let token = this.$route.query.token;
        this.loading = true;
        setTimeout(() => {
            self.$message({
                message:this.$t('btnText.loginSuccess'),
                type: 'success',
                duration:1800,
                offset:200
            });
            self.$localStorage.setItem('token',token);
            self.$localStorage.setItem('token_type','Bearer');
            self.$router.push('/');        
            // self.$store.commit('setToken',self.$route.query.token);
            // self.$store.commit('setTokenType','Bearer');
            // self.getUserInfo();
            // self.$store.commit('mergeCart');
            self.loading = false;
        }, 1000);
    },
    methods:{
    }
}
</script>
<style scoped>
.loading {
    position: absolute;
    left: 0;
    top: 0;
    background: url('../assets/img/loadding.gif') center center no-repeat rgb(96, 96, 96, 0.8);
    background-size:60px auto;
    width: 100%;
    height: 100%;
    z-index: 1000;
}
</style>


// WEBPACK FOOTER //
// src/common/OtherLogin.vue